import * as React from 'react';
import {ModelHttpService} from '../components/services/modelHttp';
import {ModelName} from '../models/names';
import {UserContext} from './user';

export enum DocumentActionType {
	FetchDocuments = 'FetchDocuments',
	SetDocuments = 'SetDocuments',
	RemoveDocument = 'RemoveDocument',
	DoneRemovingDocument = 'DoneRemovingDocument',
	UpdateDocument = 'UpdateDocument',
}
type Action = {type: DocumentActionType, payload?: any}

const initialState = {
	loading: true,
	fetching: false,
	items: [] as IDocument[],
	remove: null as null | IDocument
}
export const DocumentContext = React.createContext({
	...initialState,
	dispatch: (_: Action) => {}
})

export function DocumentProvider(props: {children?: React.ReactNode}) {

	const user = React.useContext(UserContext);
	const project = user.currentProject as IProject;
	const [state, dispatch] = React.useReducer(reducer, initialState);

	// Reducer sideeffects
	React.useEffect(() => void fetchDocuments(), [state.fetching])
	React.useEffect(() => void removeDocument(), [state.remove])

	// The reducer takes care of state updates.
	function reducer(state: typeof initialState, action: Action) {
		switch (action.type) {
			case DocumentActionType.FetchDocuments:
				return {...state, loading: true, fetching: true}
			case DocumentActionType.SetDocuments:
				return {...state, loading: false, items: action.payload, fetching: false}
			case DocumentActionType.RemoveDocument:
				return {...state, loading: true, remove: action.payload}
			case DocumentActionType.DoneRemovingDocument:
				return {...state, loading: false, remove: null}
			case DocumentActionType.UpdateDocument:
				updateDocument(action.payload)
				const items = state.items.reduce((acc, i) => {
					if (i._id == action.payload._id)
						acc.push(action.payload)
					else
						acc.push(i)
					return acc
				}, [] as IDocument[])
				return {...state, items}
			default:
				return state
		}
	}

	// Updates a single document
	async function updateDocument(document: IDocument) {
		const http = new ModelHttpService
		await http.update(ModelName.Document, document)
	}

	// Remove document from database
	async function removeDocument() {
		if (state.remove == null) return
		const http = new ModelHttpService;
		try {
			await http.delete(ModelName.Document, state.remove)
			const payload = state.items.filter((i: IDocument) => i !== state.remove)
			dispatch({type: DocumentActionType.SetDocuments, payload})
		} catch (err) {
			console.error(err)
		} finally {
			dispatch({type: DocumentActionType.DoneRemovingDocument})
		}
	}

	// Fetch all documents from the database that belongs to currentProject
	async function fetchDocuments() {
		if (state.fetching == false) return
		const http = new ModelHttpService;
		const payload = await http.find<IDocument>(ModelName.Document, {project: project._id} as Partial<IDocument>);
		dispatch({type: DocumentActionType.SetDocuments, payload})
	}

	return (
		<DocumentContext.Provider value={{...state, dispatch}}>
		{props.children}
		</DocumentContext.Provider>
	)
}

